import * as React from 'react';
import Select, { MenuPlacement } from 'react-select';
import { ActionMeta, GroupTypeBase, ValueType } from 'react-select/src/types';
import { customStyles } from 'components/inputs/MultiSelectStyles';
import { SelectComponentsConfig } from 'react-select/src/components';

export interface SelectOption<TValue extends string | number | null> {
  label: string;
  description?: string;
  value: TValue;
}

type Props<T extends string | number | null> = {
  id: string;
  isMulti?: boolean;
  value?: SelectOption<T> | SelectOption<T>[] | null | undefined;
  className?: string;
  options: SelectOption<T>[];
  menuPlacement?: MenuPlacement;
  onChange: (
    selectOptions: ValueType<SelectOption<T>, boolean>,
    actionsMeta: ActionMeta<SelectOption<T>>
  ) => void;
  defaultValue?: ValueType<SelectOption<T>, boolean>;
  components?:
    | SelectComponentsConfig<
        SelectOption<T>,
        boolean,
        GroupTypeBase<SelectOption<T>>
      >
    | undefined;
  label?: string;
  isClearable?: boolean;
};

function BaseSelect<T extends string | number | null>(props: Props<T>) {
  const { id, label, isMulti = false, menuPlacement = 'auto', ...rest } = props;

  return (
    <Select
      styles={customStyles}
      aria-label={label}
      inputId={`${id}-select`}
      menuPlacement={menuPlacement}
      isMulti={isMulti}
      {...rest}
    />
  );
}

BaseSelect.displayName = 'BaseSelectFunc';

export default BaseSelect;
